import React from 'react';
import PropTypes from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import { getEntryCardData } from '../../model/utils';
import { AddAssetEntryCard } from '../add-asset-entry-card';

import { EmptyViewIcons } from '../../asset-images';
import { useLibraryEmptyViewStyle } from '../ads-studio-library-page-content/styles/empty-view-style';

export const LibraryEmptyView = ({
  i18n,
  isInSubfolder,
  isAnyFilterSet,
  onClickStock,
  onClickCreate,
  onClickUpload,
  onClickWebsite,
  onClickInvest,
  hideAddAssetCards,
  isXandrIntegrationEnabled,
}) => {
  const cardData = getEntryCardData({
    i18n,
    onClickCreate,
    onClickUpload,
    onClickStock,
    onClickWebsite,
    onClickInvest,
    isXandrIntegrationEnabled,
  });

  const classes = useLibraryEmptyViewStyle();

  let str = i18n.getString(_TL_('You haven\'t added any assets yet. Choose from the options below to add assets.'));
  if (isAnyFilterSet) {
    str = i18n.getString(_TL_('No assets match your search. Please try again.'));
  } else if (isInSubfolder) {
    str = i18n.getString(_TL_('You haven\'t added any assets to this folder yet. Once you add assets, you\'ll see them here.'));
  }

  return (
    <div className={mergeClasses('empty-view-box', classes.emptyView)}>
      <div className={mergeClasses('empty-icon', classes.emptyIcon)}>
        <img src={EmptyViewIcons.LibraryEmptyViewSVG} alt="Empty Icon" />
      </div>
      <div className={mergeClasses('main-text', classes.mainText)}>
        {str}
      </div>
      {
        !hideAddAssetCards &&
        <div className={mergeClasses('card-container', classes.CardContainer)}>
          {cardData.map(card => (
            <AddAssetEntryCard
              key={card.key}
              id={card.key}
              description={card.description}
              title={card.title}
              imageSrc={card.image}
              onClick={card.onClick}
            />
          ))}
        </div>
      }
    </div>
  );
};

LibraryEmptyView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isInSubfolder: PropTypes.bool,
  isAnyFilterSet: PropTypes.bool,
  onClickStock: PropTypes.func.isRequired,
  onClickCreate: PropTypes.func.isRequired,
  onClickUpload: PropTypes.func.isRequired,
  onClickWebsite: PropTypes.func.isRequired,
  onClickInvest: PropTypes.func.isRequired,
  hideAddAssetCards: PropTypes.bool,
  isXandrIntegrationEnabled: PropTypes.bool,
};

LibraryEmptyView.defaultProps = {
  isInSubfolder: false,
  isAnyFilterSet: false,
  hideAddAssetCards: false,
  isXandrIntegrationEnabled: false,
};
